import Styles from './DesignContent.module.scss'
import cx from 'classnames'
import { ReviseDesignProcessingContent } from 'api/clients/ChatClient'
import { Text } from 'blaze-ui/Text/Text'
import { useEffect, useState } from 'react'

const DesignPreviewLoading = ({ aspectRatio }: { aspectRatio: number }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const duration = (Math.random() * 90 + 30) * 1000
    const startTime = Date.now()

    const interval = setInterval(() => {
      const elapsed = Date.now() - startTime
      const currentProgress = Math.min((elapsed / duration) * 100, 90)

      setProgress(currentProgress)

      if (currentProgress >= 100) {
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [])

  return (
    <div
      className={Styles.designPreviewLoading}
      style={{ width: '100%', aspectRatio }}
      data-testid="design-preview-loading"
    >
      <div className={Styles.designPreview} />
      <div className={Styles.progressContainer}>
        <div className={Styles.progressOverlay}>
          <div className={Styles.progressBar}>
            <div className={Styles.progressFill} style={{ width: `${progress}%` }} />
          </div>
        </div>
      </div>
    </div>
  )
}

export const DesignProcessingMessage = ({ content }: { content: ReviseDesignProcessingContent }) => {
  const { width, height, count } = content

  const aspectRatio = width / height

  return (
    <>
      <div
        className={cx(Styles.designPreviewContainer, { [Styles.fullWidth]: count === 1 || width > height })}
        data-testid="design-processing-message"
      >
        {Array.from({ length: count }).map((_, id) => (
          <DesignPreviewLoading key={id} aspectRatio={aspectRatio} />
        ))}
      </div>
      <Text variant="metadata" color="var(--dark-40)">
        This might take 1-2 minutes
      </Text>
    </>
  )
}
